import { cn } from '@/lib/utils';

export type LEDState = 'inactive' | 'active' | 'complete' | 'error';

interface LEDIndicatorProps {
  state: LEDState;
  className?: string;
}

export const LEDIndicator: React.FC<LEDIndicatorProps> = ({ state, className }) => {
  return (
    <span
      className={cn(
        'inline-block rounded-full shrink-0 transition-all duration-300',
        state === 'inactive' && 'led-dot',
        state === 'active'   && 'led-dot led-dot-active led-dot-amber led-breathe-amber',
        state === 'complete' && 'led-dot led-dot-active led-dot-green',
        state === 'error'    && 'led-dot led-dot-active led-dot-red',
        className,
      )}
    />
  );
};
